import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=20e0634c&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
import style0 from "./Container.vue?vue&type=style&index=0&id=20e0634c&prod&scoped=true&lang=scss"
import style1 from "./Container.vue?vue&type=style&index=1&id=20e0634c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e0634c",
  null
  
)

export default component.exports